"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropdownItem = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../../foundations");
const TextV2_1 = require("../../../foundations/Typography/TextV2");
const renderIcon = (icon) => {
    if (!icon) {
        return null;
    }
    if (icon.type === "flag") {
        return react_1.default.createElement(foundations_1.FlagIconV2, { flag: icon.name });
    }
    return react_1.default.createElement(foundations_1.IconV2, { icon: icon.name });
};
const DropdownItem = ({ option, isFocused, idx }) => {
    const optionRef = react_1.default.useRef(null);
    // If options is focused but hidden by overflow,
    // scroll the dropdown to show the focused option
    react_1.default.useEffect(() => {
        if (isFocused && optionRef.current) {
            optionRef.current.scrollIntoView({
                behavior: "smooth",
                block: "nearest"
            });
        }
    }, [isFocused]);
    const { label, icon } = option;
    const dropdownItemContainerStyles = Object.assign({ cursor: "pointer", width: "100%", px: "spacing-5", py: "spacing-3", transition: "background-color 100ms", ":hover": {
            backgroundColor: "surface-brand"
        } }, (isFocused && {
        backgroundColor: "surface-brand"
    }));
    const dropdownItemStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: "spacing-4",
        py: "spacing-2",
        ":active": {
            // TODO: figure out how to make this work for dropdown but hide for searchbar
            borderLeft: "3px solid",
            borderColor: "onSurface-brand-primary"
        }
    };
    return (react_1.default.createElement(foundations_1.Box, { as: "li", ref: optionRef },
        react_1.default.createElement(foundations_1.Box, { as: "button", "data-element-idx": idx, "aria-selected": isFocused, role: "option", tabIndex: -1, sx: Object.assign({}, dropdownItemContainerStyles) },
            react_1.default.createElement(foundations_1.Box, { sx: Object.assign({}, dropdownItemStyles) },
                react_1.default.createElement(TextV2_1.TextV2, { variant: "body-1-regular", sx: { color: "currentColor" } }, label),
                react_1.default.createElement(foundations_1.Box, { sx: { flexShrink: 0, display: "flex", alignItems: "center" } }, renderIcon(icon))))));
};
exports.DropdownItem = DropdownItem;
//# sourceMappingURL=DropdownItem.js.map